import type {
  BookingOrderEditApiData,
  BookingOrderEditApiResponses,
  BookingOrderEditPreviewApiData,
  BookingOrderEditPreviewApiResponses
} from '@navio/nsdk';

import { apiUrl, responseEndpoint } from '../defineResource';

export const orderEditUrls = {
  postBookingOrderEditPreview: responseEndpoint<BookingOrderEditPreviewApiData, BookingOrderEditPreviewApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/order-edit/preview/`),
    getBody: (data) => data
  }),
  postBookingOrderEdit: responseEndpoint<BookingOrderEditApiData, BookingOrderEditApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/order-edit/`),
    getBody: (data) => data
  })
};
